import { render, staticRenderFns } from "./YoungDetailsList.vue?vue&type=template&id=7593ff8e&"
import script from "./YoungDetailsList.vue?vue&type=script&lang=js&"
export * from "./YoungDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./YoungDetailsList.vue?vue&type=style&index=0&id=7593ff8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports